export default __webpack_public_path__ + "static/media/first-place.23ef5937.svg";